<template>
    <div class="wrapper">
        <p  class="wonde-new-integration">{{ $t('integrations.newIntegrationFor') }} Wonde </p>
        <div>
            <h5 class="school-token">
                {{ $t('integrations.haveToken') }}
            </h5>
        </div>
        
        <div>
          <v-radio-group v-model="isExtraScenario">
            <v-radio v-for="option in haveTokenOptions" :key="option.value" :label="option.text" :value="option.value"></v-radio>
          </v-radio-group>
        </div>
        <hr class="vertical-line" />
        <div class="modal-actions-btns">
            <VpButton :text="$t('common.next')" :disabled="getLoading" @click="onSubmit()" />
            <VpButton :text="$t('common.cancel')" :width="getReAuth ? '130px' : '112px'" :isDanger="true" @click="$bvModal.hide('wondeFlow')" />
        </div>
    </div>
</template>
  
<script>
import { mapGetters, mapActions } from "vuex";
export default {
    components: {},
    data: function () {
        return {
            submitted: false,
            haveTokenOptions: [
                {
                    text: this.$t('integrations.iHaveToken'),
                    value: 0,
                }, {
                    text: this.$t('integrations.iDontHaveToken'),
                    value: 1,
                }
            ],
            isExtraScenario: 0
        };
    },

    methods: {
        ...mapActions("integration", [
            "setWondeHaveTokenValue"
        ]),
        onSubmit() {

            if (this.isExtraScenario) {
                this.$bvModal.show("extraScenario");
            } else {
                this.$bvModal.show("addIntegration");
            }
            this.$bvModal.hide('wondeFlow')
        },
    },
    computed: {
        ...mapGetters("modal", ["getModalInfo"]),
        ...mapGetters("integration", [
            "getLoading",
            "getModalState",
            "getReAuth",
            "getWondeHaveTokenValue"
        ]),
    },
    watch: {
        getModalState(state) {
            state == true && this.$bvModal.hide("wondeFlow");
        },
    },
    mounted() { },
    beforeMount() {

    },
};
</script>
<style lang="scss" scoped>
@import '../../assets/css/modal.scss';
</style>
  